/* eslint-disable @typescript-eslint/no-explicit-any */
export interface FromNativeOrWxParam {
  shareId?: string; // 分享令牌
  download?: string;
  activityId?: string; // 分享的活动id
  shareUserId: string; // 分享uid
  shareType: number; // 1 图片 2 视频 3 直播 4/0/undefined 其他（图片）
  shareForm: number | string; //  // 0 app 1wx  miaowa_app_share_wechat_friend-分享微信好友 miaowa_app_share_pyq-分享微信朋友圈
  fromPageId: string;
  orderId?: string; // 宠爱到家订单号
  blockType?: number;
  applyOrderId?: string;
  businessId?: string; // 当前的id
  catHouseName?: string; // 有页面title, 没有“hello 街猫”
  appVersion?: string;
  skipScene?: number;
  catHouseId?: string;
  others?: { [key: string]: any } // 其他
  title?: string; // 分享主标题
  subTitle?: string; // 分享副标题
  autoJump?: number | string;// 是否自动跳转
  groupId?: string; // 群聊id
  bifrostCode?: string // 跳转何方, 跳转mpaas场景值
  topicId?: string; // 话题id
  roomId?: string; // 用户视角主播直播间id
  userId?: string; // 主播id
  router?: string; // 'openWeb'; // 打开app webview
  source?: number;
  type?: string;
  sponsorshipId?: string; // 品牌商活动id
  webUrl?: string;
  mpPage?: string; // 小程序路由
}

export interface ToNatieParam {
  shareUserId: string; // 分享uid
  appPlatform: 'ios' | 'android' | 'other';
  shareForm: number; // 0 app  1wx  2其他
  fromPageId?: string;
  applyOrderId?: string;
  blockType?: number;
  businessId?: string; // 当前的id
  others?: { [key: string]: any } // 其他字段
}

export enum SHARE_WAYS {
  PIC = 1,
  VIDEO = 2,
  LIVING = 3,
  VIP_MGM = 4,
  SPRING_SHARE = 5,
  OTHER = 99,
}

export enum ShareSceneEnum {
  BRAND = 11, // 赞助分享
}
export enum ShareTypeEnum {
  BRAND = 6, // 赞助分享
}
export enum ShareFormEnum {
  BRAND = 'sponsorship', // 赞助分享
}

/**
 * 选秀活动类型
 */
export enum DraftActivityTypeEnum {
  CAT = 11,
  CAT_HOUSE = 14,
  NAI_XUE = 16
}

/**
 * Ulink配置
 */
export interface LinkConfig {
  id: string; // 必填参数,后台生成的linkid
  data?: Record<string, unknown>; // 自定义参数例如{a:1,b:2} 换起应用时会携带过去并映射成a=1&b=2
}
/**
 * 配置下发回调
 */
export type ReadyCallback = {
  // eslint-disable-next-line no-use-before-define
  (ctx: LinkInstance): void;
};
/**
 * 配置下发内容
 */
export interface ISolutions {
  wakeupUrl: string; // 唤起地址
  type: 'scheme' | 'universalLink'; // 唤起类型
  downloadUrl: string; // 下载地址
  appkey: string; // 对应appkey
  clipboardToken?: string; // 友盟后台开启剪切板能力时返回此字段，开启后可提高带参安装匹配成功率。
}

export type ICallback = {
  // eslint-disable-next-line no-use-before-define
  (ctx: LinkInstance): void;
};
export type defaultActionCallback = {
  (extdata?: Record<string, unknown>): void;
};
export type IProxyOpenDownload = {
  // eslint-disable-next-line no-use-before-define
  (defaultAction: defaultActionCallback, ctx: LinkInstance): any;
  // 如仍需执行默认弹窗行为可调用defaultActionCallback
};
export interface IWakeup {
  action?: '' | 'load' | 'click'; // 设置统计上报的唤起方式
  proxyOpenDownload?: IProxyOpenDownload; // 代理打开下载提示行为
  beforeOpenDownload?: ICallback;
  afterOpenDownload?: ICallback;
  timeout?: number; // 触发弹窗等待超时时间单位毫秒，默认200毫秒，安卓中微信强制为0
}

/**
 * Ulink实例
 */
export interface LinkInstance {
  ready(callback: ReadyCallback): void; // 配置下发
  wakeup(config: IWakeup): LinkInstance; // 唤起
  solution: ISolutions; // 配置下发内容
}
